import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Typography
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import useData from "../../Hooks/useData";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import { blue } from "@mui/material/colors";
import { serviceIcons } from "../../constants/serviceIcons";
import { Helmet } from "react-helmet-async";

const Services = () => {
  // const [ourServices, setOurServices] = useState([])
  const services = useData();
  return (
    <>
    <Helmet>
      <title>Services | Den Den Claw | Ottawa Arcade</title>
      <meta
        name="description"
        content="Explore everything Den Den Claw has to offer — claw machines, Artist Alley, photobooth, memberships, gift cards, machine rentals, and community events in Ottawa."
      />
      <link rel="canonical" href="https://www.dendenclaw.com/services" />
    </Helmet>
    <Box
      id="services"
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: blue[100],
        color: "primary.main",
        p: 2,
        mb: 2,
        mt: 6,
        textAlign: "center",
      }}
    >
      {services.length > 1 ? (
        <Container maxWidth="xl">
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 700,
                      mb: 1,
                    }}
                  >
                    Explore What We Offer
                  </Typography>
          
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 6,
                      color: "text.secondary",
                      maxWidth: 700,
                      mx: "auto",
                    }}
                  >
                    From skill-based claw machines to community events and creative spaces,
                    here’s what makes Den Den Claw special.
                  </Typography>

          <Grid container spacing={3} style={{justifyContent: 'center'}}>
            {services?.map((service) => (
              <Grid key={service.id} item xs={12} sm={6} md={6} lg={4} style={{justifyContent: 'center'}} >
       <Card
  sx={{
    mx: "auto",
    maxWidth: 345,
    borderRadius: 3,
    cursor: "pointer",
    transition: "all 0.35s ease",
    "&:hover": {
      boxShadow: 10,
      transform: "translateY(-4px)",
    },
    "& img": {
      transition: "transform 0.35s ease",
    },
    "&:hover img": {
      transform: "scale(1.05)",
    },
    "&:hover .service-title": {
      color: "#0f7ca4",
    },
  }}
>

                  <CardActionArea component={Link} to={`/explore/${service.slug}`}>
                    <CardMedia
                      component="img"
                      height="240"
                      image={service?.service_img}
                      srcSet={service?.service_img_srcset}
                      sizes={service?.service_img_sizes}
                      loading="lazy"
                      decoding="async"
                      alt={service.treatment}
                    />
  <CardContent
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    my: 2,
  }}
>
  {(() => {
    const Icon = serviceIcons[service.iconKey];
    return (
      Icon && (
        <Icon
          sx={{
            fontSize: 44,
            color: "primary.main",
            transition: "transform 0.3s ease",
            ".MuiCard-root:hover &": {
              transform: "scale(1.15)",
            },
          }}
        />
      )
    );
  })()}

  <Typography
    className="service-title"
    variant="h5"
    sx={{ fontWeight: 600, textAlign: "center" }}
  >
    {service.treatment}
  </Typography>

  {/* subtle affordance */}
  <Typography
    variant="body2"
    sx={{
      color: "text.secondary",
      opacity: 0.8,
      transition: "opacity 0.3s ease",
      ".MuiCard-root:hover &": {
        opacity: 1,
      },
    }}
  >
    Learn more →
  </Typography>
</CardContent>

                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>

          <HashLink smooth to="/#home" className="text-style">
            {" "}
            <Button
              variant="contained"
              color="primary"
              startIcon={<HomeIcon />}
              sx={{ mb: 5, mt: 5 }}
            >
              Back to Home
            </Button>
          </HashLink>
        </Container>
      ) : (
        <LoadingScreen></LoadingScreen>
      )}
    </Box>
    </>
  );
};

export default Services;
